module.exports = __webpack_public_path__ + "static/img/Body-11.9bb2ff56.jpg";